export const buildCreateMessageTemplateRequest = (formData) => {
	return {
		language: formData.language,
		useCaseId: formData.useCase.id,
		brandId: formData.brand.id > 0 ? formData.brand.id : null,
		outletId: formData.outletId > 0 ? formData.outletId : null,
		body: formData.body,
		isWaitsOnPremiseDependent: formData.isWaitsOnPremiseDependent,
		isWaitsOnPremise: formData.isWaitsOnPremise,
	};
};

export const buildUpdateMessageTemplateRequest = (formData) => {
	return {
		body: formData.body,
		isWaitsOnPremiseDependent: formData.isWaitsOnPremiseDependent,
		isWaitsOnPremise: formData.isWaitsOnPremise,
	};
};
